<template>
  <edit ref="edit"></edit>
</template>

<script>
import Edit from './EditForm'
export default {
  components: {
    Edit
  },
  mounted () {
    this.$refs.edit.new()
  }
}
</script>
